// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__3EMGA","plain":"style_plain__e2m9a","title":"style_title__tFTy9","icon":"style_icon__21ZtR"};